import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";

interface WorkforceActionsProps {
	onAddClick: () => void;
}

export const WorkforceActions = ({ onAddClick }: WorkforceActionsProps) => {
	const { t } = useTranslation();

	return (
		<div className="flex items-center gap-2">
			<Button onClick={onAddClick} className="gap-2">
				<Plus className="h-4 w-4" />
				{t("workforce.actions.addWorkforce", "Add Assignment")}
			</Button>
		</div>
	);
};
